export const LATEST_SEARCH_GAMES = 'LATEST_SEARCH_GAMES';
export const GAME_SEARCH_HEADER_ID = 'gameSearch_header';
export const DELAY_GAME_SEARCH_INPUT_IN_FOCUS = 100;
export const DEFAULT_SEARCH_LIST = [];
